module.exports = __webpack_public_path__ + "img/sect4-55.4222fab5.png";